export default {
  area: '审批流程',
  objectName: '审批流程',
  point: { lng: 111.881007, lat: 34.75317 },
  mapAttr: {
    mapType: 'BMAP_NORMAL_MAP',
    zoom: 13,
  },
  //url
  // http://192.168.1.9:8068/
  // ParentUrl: 'http://192.168.1.16:8087/',
  // apiHttpsUrl: 'http://192.168.1.16:9527/',
  // apiRequestUrl: 'http://192.168.1.16:9527/',
  // apiUploadUrl: 'http://192.168.1.16:9527/OA/common/OssUploadImg',
  // apiUploadFiles: 'http://192.168.1.16:9527/api/UploadFile/UploadImgOrFile',


  // ParentUrl: 'http://192.168.1.26:8070/',
  // apiHttpsUrl: 'http://192.168.1.26:8070/',
  // apiRequestUrl: 'http://192.168.1.26:8070/',
  // apiUploadUrl: 'http://192.168.1.26:8070/common/OssUploadImg',
  // apiUploadFiles: 'http://192.168.1.26:8070/9api/UploadFile/UploadImgOrFile',

  ParentUrl: 'https://clockin.anluoyun.cn/prod-api/',
  apiHttpsUrl: 'https://gateway.anluoyun.cn/',
  apiRequestUrl: 'https://gateway.anluoyun.cn/',
  apiUploadUrl: 'https://gateway.anluoyun.cn/OA/common/OssUploadImg',
  apiUploadFiles: 'https://gateway.anluoyun.cn/api/UploadFile/UploadImgOrFile',



  // ParentUrl: 'http://192.168.1.14:8070/',
  // apiHttpsUrl: 'http://192.168.1.14:9527/',
  // apiRequestUrl: 'http://192.168.1.14:9527/',
  // apiUploadUrl: 'http://192.168..1.14:9527/OA/common/OssUploadImg',
  // apiUploadFiles: 'http://192.168..1.14:9527/api/UploadFile/UploadImgOrFile',

  // ParentUrl: 'http://192.168.110.220:9527/',
  // apiHttpsUrl: 'http://192.168.110.220:9527/',
  // apiRequestUrl: 'http://192.168.110.220:9527/',
  // apiUploadUrl: 'http://192.168.110.220:9527/OA/common/OssUploadImg',
  // apiUploadFiles: 'http://192.168.110.220:9527/api/UploadFile/UploadImgOrFile',
  //
  // ParentUrl: 'http://192.168.1.8:9527/prod-api/',
  // apiHttpsUrl: 'http://192.168.1.8:9527/',
  // apiRequestUrl: 'http://192.168.1.8:9527/',
  // apiUploadUrl: 'http://192.168.1.8:9527/OA/common/OssUploadImg',
  // apiUploadFiles: 'http://192.168.1.8:9527/api/UxploadFile/UploadImgOrFile',
}
